import api from '@/api_alv'
import i18n from '@/assets/i18n/i18n'

const DIR = 'account/settings'

const state = {
    publishingSettings: {},
    labelSettings: {},
    showUploadDialog: false
}

const getters = {
    getPublishingSettings(state) { return state.publishingSettings },
    getLabelSettings(state) { return state.labelSettings },
    getShowUploadDialog(state) { return state.showUploadDialog },
}

const mutations = { 
    setPublishingSettings: (state, settings) => { state.publishingSettings = settings },
    setLabelSettings: (state, settings) => { state.labelSettings = settings },
    setShowUploadDialog: (state, show) => { state.showUploadDialog = show },
}

const actions = {
    async fetchPublishingSettings({ commit, getters }) {
        commit('setIsLoading', true)
        let response = await api.getDetailsById(DIR, getters.getSelectedOverAllCompany.alvId) 
        commit('setIsLoading', false)

        if(response === undefined || response.length === 0 || response.error === 1) response = {}
        
        commit('setPublishingSettings', response)
    },
    async fetchLabelSettings({ commit, getters }) {
        commit('setIsLoading', true)
        let response = await api.getDetailsById(DIR, getters.getSelectedOverAllCompany.alvId) 
        commit('setIsLoading', false)

        if(response === undefined || response.length === 0 || response.error === 1) response = {}

        commit('setLabelSettings', response)
    },

    async uploadA6BackgroundImage({ getters }, params) {
        let settingsId = params.item.id
        let companyId = params.item.company
        let companyContext = getters.getSelectedOverAllCompany.context
        let urlParams = "?type=a6&default=1&settingId="+ settingsId + "&companyId="+ companyId + "&companyContext=" + companyContext
        
        return await api.putFile(DIR, params.file, urlParams).then(res => res)
    },
    async deleteA6BackgroundImage({}, data) {
        return await api.deleteFile(DIR, '?type=a6', data).then(response => response)
    },

    async saveSettings({ getters, commit, dispatch }, metaData) {
        let companyAlvId = getters.getSelectedOverAllCompany.alvId

        let response = await api.saveSettings(companyAlvId, metaData)
        if(response === undefined || response.error === 1) {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t(response.errorMsg)
            })

        } else {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_ACCOUNT_SETTINGS_SNACKBAR_SUCCESSFULLY_SAVED')
            })
            dispatch('fetchPublishingSettings')
            dispatch('fetchLabelSettings')
        }
    }
}

export default {
    state, getters, actions, mutations
}